import { qs, on } from '../utils/dom';
import { MenuAppear } from './menu';

export function initHamburger() {
  const btn = qs('.header--menu-hamburger .hamburger');
  const headerFull = qs('.header--full');
  if (!btn || !headerFull) return;

  on(btn, 'click', () => {
    btn.classList.toggle('is-active');
    headerFull.classList.toggle('is-active');

    const isOpen = btn.classList.contains('is-active');
    MenuAppear(isOpen);
  });
}